import React, { Fragment } from 'react';
import { getAllowedRoutes } from '../utils/getAllowedRoutes.js';
import { PrivateRoutesConfig } from './Routesconfig.js';
import Sidenav from '../shared/Sidenav';
import { roles } from '../utils/constants.js';
import { useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import config from '../../src/config.js'
function AllowedRoutes() {
  const Setb2b_permissions = useSelector((state) => state.Head.b2b_permissions)
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const new_user_type = useSelector((state) => state.Head.new_user_type)
try {

  let allowedRoutes = [];
  allowedRoutes = getAllowedRoutes(PrivateRoutesConfig);

  if (localStorage.getItem('role') === roles.b2b) {
    // let b2b_permissions = Setb2b_permissions[0]
    // let b2b_permissions = JSON.parse(localStorage.getItem("b2b_permissions"))[0]
    const encryptedPermissions = localStorage.getItem("b2b");
    // Decrypt the permissions with the same secret key
    const decryptedPermissionsBytes = CryptoJS.AES.decrypt(encryptedPermissions, config.B2B_SECRET_KEY);


    // Convert the decrypted bytes back to a JSON string
    const decryptedPermissionsJSON = decryptedPermissionsBytes.toString(CryptoJS.enc.Utf8);

    // Parse the JSON string to get the original object
    const b2b_permissions = JSON.parse(decryptedPermissionsJSON)[0];

    // Now, you can use the originalPermissions object

    allowedRoutes = allowedRoutes.filter((item) => {

      if (b2b_permissions?.newspaperData && item.path === "/home/competitor_data/get") {
        return true
      }
      if (b2b_permissions?.newspaperData && item.path === "/home/saleswise_interactions") {
        return true
      }
      if (b2b_permissions?.b2bData && item.path === "/home/b2b_contacts/get") {
        return true
      }
      if (b2b_permissions?.agencyData && item.path === "/home/agency_data/get") {
        return true
      }
      if (b2b_permissions?.competitorData && item.path === "/home/competitor_reports/get") {
        return true
      }
      if (b2b_permissions?.requests && item.path === "/home/b2b_requests/get") {
        return true
      }
      if(b2b_permissions?.brands && item.path === "/home/brands"){
        return true
      }
      if(b2b_permissions?.newspapers && item.path === "/home/newspaper_data"){
        return true
      }
      if(b2b_permissions?.planning && item.path === '/home/planning'){
        return true
      }
      if(b2b_permissions?.buildup && item.path === '/home/buildup'){
        return true
      }
      if(b2b_permissions?.reports && item.path === '/home/brandreports'){
        return true
      }
      if (item.path === "/home/page_rates") {
        return true
      }
      if (item.path === "/home/editions") {
        return true
      }
      if(item.path === '/home/help'){
        return true
      }
      if(item.path==='/home/campaign_info'){
        return true;
      }
      if(item.path === '/home/monthlyreview'){
        return true
      }
      if(item.path === '/home/birdviewai'){
        return true
      }
      if(item.path === '/home/birdview-reject'){
        return true
      }
      if(item.path === '/home/birdview-alpha'){
        return true
      }
      if(item.path === '/home/salesreports'){
        return true
      }
      if(item.path === '/home/users'){
        return true
      }
      if(item.path === '/home/newspaper-viewer-alpha'){
        return true
      }
      if(item.path === '/home/newspaper-viewer'){
        return true
      }
      if(item.path === '/home/alphacompetitor_reports/get')
        return true
      if(item.path === '/home/brandlocations')
        return true
      if(item.path === '/home/eenadu/page_rates')
        return true
      if(item.path==='/home/phionex_reports') return true;
      if(item.id===76) return false
    })
  }

  if (localStorage.getItem('role') === roles.salesperson && localStorage.getItem('salesTabFlag')) {
    const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(localStorage.getItem('salesTabFlag'), config.B2B_SECRET_KEY);
    const salesKeyString = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8);
    allowedRoutes = allowedRoutes.filter(item => {
      if(item.id===73 || item.id===76){
        return false;
      }
      if (item.id === 10) {
        if (salesKeyString === "Main" || salesKeyString === "LocalHead")
          return true
        else
          return false
      }
      if (item.id === 1 || item.id === 26 || item.id === 57 || item.id === 59 || item.id === 63 || item.id === 85) {
        if (salesKeyString === "Main" || salesKeyString === "LocalHead" || salesKeyString === "NationalHead" || salesKeyString === "RegionHead")
          return true
        else
          return false
      }
      if(item.id === 72){
        return config.SALES_EMAILS_B2B_REPORTS.includes(localStorage.getItem('email'));
      }
      else
        return true
    })
  }
  else {
    allowedRoutes = allowedRoutes.filter(item => {
      if(item.id === 45){
        if(salesUsersList.length > 1)
          return true
        else
          return false
      }
      if ((item.id === 10 || item.id === 1  || item.id === 26 || item.id === 57 || item.id === 59 || item.id === 63 || item.id === 85) && localStorage.getItem('role') === roles.salesperson) {
        return false
      }
      else
        return true
    })
  }

  if (localStorage.getItem('role') === roles.salesperson && localStorage.getItem('email') !== "raghu@way2news.com") {
    allowedRoutes = allowedRoutes.filter(item => {
      if (item.id === 22) {
        return false
      }
      else
        return true
    })
  }
  if(localStorage.getItem('role') === roles.salesperson){
    if(!localStorage.getItem('sales_team')){
        allowedRoutes = allowedRoutes.filter(item => {
          if(item.id === 54)
            return false
          else return true
        })
    }
    else{
      const decryptSalesTeam = CryptoJS.AES.decrypt(localStorage.getItem('sales_team'), config.B2B_SECRET_KEY);
      const sales_team = decryptSalesTeam?.toString(CryptoJS.enc.Utf8) || '';
      if(!config.CARDLIST_TEAMS?.includes(sales_team)){
        allowedRoutes = allowedRoutes.filter(item => {
          if(item.id === 54)
            return false
          else return true
        })
      }
    }
    if(new_user_type !== 9){
      allowedRoutes = allowedRoutes.filter(item => {
        if(item.id === 83)
          return false
        else return true
      })
    }

  }
    if(localStorage.getItem('role')===roles.financer){
      allowedRoutes = allowedRoutes.filter(item=>{
         if(item.id===73 || item.id===76) return false;
         else return true;
      })
    }
    if (localStorage.getItem('role') === roles.ops && !config.CSTUsers.includes(localStorage.getItem('email'))) {
      allowedRoutes = allowedRoutes.filter(item => {
        if (item.id === 73) {
          return false;
        }
        if (item.id === 1) {
          return false
        }
        else
          return true
      })
    }
    if(localStorage.getItem("role") === roles.ops && !config.DEVS.includes(localStorage.getItem('email'))){
       allowedRoutes = allowedRoutes.filter(item => {
         if(item.id===64) return false;
         else return true;
       })
    }
    return (
      <Fragment>

        <Sidenav
          routes={allowedRoutes}
        />
      </Fragment>
    );
  } catch (error) {
    console.error("Error @ Allowed Routes", error)
  }
}

export default AllowedRoutes;